<template>
  <div class="patent">
    <!-- 导航栏 -->
    <div class="patent.block">
      <intellectual-navigation
        :isTrademark="isTrademark"
        @toggleTrademarks="toggleTrademarks"
      ></intellectual-navigation>
    </div>
    <div class="+navigation-line"></div>
    <!-- 面包屑 -->
    <div class="patent.bread" data-aos="fade-left">
      <Bread :currentPage="{ name: '专利信息', path: '/Patent' }" />
    </div>
    <div class="patent.container">
      <div class="patent.item +content-box">
        <section>
          <!-- 筛选菜单 -->
          <SelectMenus
            :allMenus="patentMenus"
            data-aos="fade-right"
            @menusTabs="menusTabs"
          ></SelectMenus>
          <!-- 筛选时间和价格 -->
          <div class="search">
            <div class="inputDiv">
              <el-input
                v-model="searchVal"
                placeholder="搜索专利名称"
                clearable
                @clear="searchEvent"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchEvent"
                ></el-button>
              </el-input>
            </div>
            <div class="totals">
              <p>
                共<span>{{ pageParams.totalMCount }}</span
                >个专利
              </p>
            </div>
          </div>
          <!-- 筛选得内容 -->
          <select-lists
            :lists="patentData"
            :pageParams="pageParams"
            :pageSize="pageSize"
            @updateLists="updateLists"
          ></select-lists>
        </section>
      </div>
    </div>
    <!-- footer -->
    <common-footer></common-footer>
    <consultation-modal
      :consultationShow="consultationShow"
      @closeConsultationEvent="closeConsultationEvent"
    ></consultation-modal>
  </div>
</template>

<script>
import axios from "axios";
import IntellectualHeader from "../components/intellectual-header.vue";
import IntellectualNavigation from "../components/intellectual-navigation.vue";
import CommonFooter from "../components/common-footer.vue";
import Bread from "../components/bread.vue";
import SelectMenus from "../components/select-menus.vue";
import SelectLists from "../components/select-lists-sp.vue";
import ConsultationModal from "../components/consultation-modal.vue";

export default {
  components: {
    IntellectualHeader,
    IntellectualNavigation,
    CommonFooter,
    Bread,
    SelectMenus,
    SelectLists,
    ConsultationModal,
  },
  data() {
    return {
      searchVal: "",
      account: 0,
      priceSort: "",
      timeSort: "",
      pageParams: {
        totalMCount: 0,
        pageMNo: 1,
      },
      pageSize: 10,
      isTrademark: false,
      consultationShow: false,
      patentMenus: [
        {
          type: "专利类型",
          lists: [],
          isShowBtn: false,
        },
        {
          type: "行业分类",
          lists: [],
          isShowBtn: true,
        },
      ],
      patentLists: [
        // {title:'SEBE 拾贝',desc:'让创新保护，不再困难',icon:require('../assets/trademarks/list-test.png'),id:0},
      ],
      type: "",
      ipc: "",
    };
  },
  computed: {
    patentData() {
      //   return this.patentLists.map(({ name, image, introduction, id }) => {
      return this.patentLists.map((item) => {
        return {
          title: item.name,
          desc: item.introduction,
          id: item.id,
          pub_card:item.pub_card
        };
      });
    },
  },
  methods: {
    closeConsultationEvent(val) {
      this.consultationShow = val;
    },
    showConsultationEvent(val) {
      this.consultationShow = val;
    },
    toggleTrademarks(val) {
      this.isTrademark = val;
    },
    initPatentLists(page) {
      page = page ? page : 1;
      this.http
        .get(
          `IPR_Patent?page=${page}&search=${
            this.$route.query.name ? this.$route.query.name : this.searchVal
          }&types=${this.type}&cates=${this.ipc}`
        )
        .then((res) => {
          this.patentLists = res.data.data;
          this.pageParams.totalMCount = res.data.total;
          this.account = res.data.total;
          let obj = res.data.types;
          let obj1 = res.data.cates;
          let arr = [],arr1=[];
          for (var key in obj) {
            arr.push({
              id: key,
              name: obj[key],
            });
          }
          this.patentMenus[0].lists = arr;
          for (var key in obj1) {
            arr1.push({
              id: key,
              name: obj1[key],
            });
          }
          this.patentMenus[1].lists = arr1;
        });

      // this.http
      //   .get(
      //     `/patent?name=${this.searchVal}&pts=${this.type}&page=${page}&page_size=8`
      //   )
      //   .then((res) => {
      //     // this.patentMenus[0].lists = res.data.pts
      //
      //     this.patentMenus[0].lists = arr;
      //     this.patentLists = res.data.rows;
      //     this.pageParams.totalMCount = res.data.total;
      //     this.pageSize = res.data.rowCount;
      //     this.account = res.data.total;
      //     this.patentLists.forEach((item) => {
      //       item.image = `${this.urlConfig.url}patent/img/${item.pn}`;
      //     });
      //   });
    },
    searchData() {
      this.initPatentLists();
      //   this.http
      //     .get(
      //       `IPR_Patent?name=${this.searchVal}&type=${this.type}&price=${this.priceSort}&check_time=${this.timeSort}`
      //     )
      //     .then((res) => {
      //       this.patentLists = res.data.data;
      //       this.pageParams.totalMCount = res.data.total;
      //       this.account = res.data.total;
      //     });
    },
    updateLists(val) {
      this.initPatentLists(val);
    },
    searchEvent() {
      this.searchData();
    },
    menusTabs(tabs) {
      let typeId = [],
        ipc = [];
      tabs.map((item, index) => {
        if (item.type.slice(0, 4) == "专利类型") {
          let index = parseInt(item.type.slice(7));
          typeId.push(this.patentMenus[0].lists[index].id);
        }
        if (item.type.slice(0, 5) == "IPC分类") {
          let index = parseInt(item.type.slice(8));
          ipc.push(this.patentMenus[1].lists[index].id);
        }
      });
      this.type = typeId.join(",");
      this.ipc = ipc.join(",");
      this.searchData();
    },
  },
  mounted() {
    this.initPatentLists();
  },
};
</script>

<style lang="scss">
@include component(patent) {
  @include part(block) {
    min-width: $minWidth;
    padding: 0 25px;
    margin: 0 auto;
    width: 100%;
    background: #fff;
  }
  @include part(bread) {
    width: 100%;
    min-width: $minWidth;
    height: 51px;
    background: #fff;
  }
  @include part(container) {
    width: 100%;
    background: #f7f7f7;
    min-width: $minWidth;
    padding: 0 25px;
    margin: 0 auto;
  }
  @include part(item) {
    width: 1200px;
    margin: 0 auto;
    padding-top: 18px;
    padding-bottom: 18px;
  }
  @include tweak(content-box) {
    display: flex;
    justify-content: space-between;
    section {
      &:nth-child(1) {
        width: 100%;
      }
      // &:nth-child(2) {
      //   width: 240px;
      // }
    }
    .search {
      width: 100%;
      height: 48px;
      margin: 28px 0 24px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .inputDiv {
        width: 950px;
        height: 100%;
        .el-input {
          width: 100%;
          height: 100%;
          .el-input__inner {
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0);
          }
          .el-input-group__append {
            width: 83px;
            height: 100%;
            background: #2278fc;
            color: #fff;
            font-size: 24px;
          }
        }
      }
      .totals {
        p {
          color: #333333;
          font-size: 20px;
          span {
            color: #2278fc;
          }
        }
      }
    }
  }
}
</style>
